var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('b-badge',{staticStyle:{"font-size":"11pt"},attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.item.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }